import { render } from "./RoomPlaceOrder.vue?vue&type=template&id=77991fd8&scoped=true"
import script from "./RoomPlaceOrder.vue?vue&type=script&lang=js"
export * from "./RoomPlaceOrder.vue?vue&type=script&lang=js"

import "./RoomPlaceOrder.vue?vue&type=style&index=0&id=77991fd8&scoped=true&lang=css"

import exportComponent from "D:\\京欣医疗用户端\\login_init\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.4.31_vue@3.4.31_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77991fd8"]])

export default __exports__